module.exports = __webpack_public_path__ + "assets/favicon-bf-de.77be798c.png";